import React from 'react';

import s from './SignIn.module.scss';
import {
  Card,
  CardBody,
  CardFooter,
  Container,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Button } from '@landsvirkjun/react.common';
import { IPublicClientApplication } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';

/**
 * A simple not found component when a user navigates to a page that does not exist.
 *
 * Simply renders an image and a "Not found" text
 */

const signInClickHandler = async (
  instance: IPublicClientApplication
): Promise<void> => {
  await instance.loginRedirect();
};

const SignInButton = (): JSX.Element => {
  const { instance } = useMsal();
  return (
    <Button
      type="button"
      variant="primary"
      onClick={(): Promise<void> => signInClickHandler(instance)}
    >
      Innskrá mig
    </Button>
  );
};

export const SignIn = (): JSX.Element => {
  return (
    <>
      <div className={s.image}>
        <div className={s.image__notfoundtext}>
          <p className={s.image__announce}>Þessi síða krefst auðkenningar</p>
        </div>
      </div>
      <Container maxW={'600px'} marginTop={'30px'}>
        <Card
          direction={{ base: 'column', sm: 'row' }}
          overflow="hidden"
          variant="outline"
        >
          <Stack>
            <CardBody>
              <Heading size="md">Þú þarft að innskrá þig</Heading>
              <Text py="2">
                Til þessa að skrá nýjar ferðabeiðnir, skoða stöðu beiðna eða
                skrá ferðakostnað, þarf að skrá sig inn á vefinn.
              </Text>
            </CardBody>
            <CardFooter justifyContent={'flex-end'}>
              <SignInButton />
            </CardFooter>
          </Stack>
        </Card>
      </Container>
    </>
  );
};
